//英语
export default{
  首页:"Index",
  我的资产:"Assets",
  重置登录密码:"Reset login password",
  重置登录密码后:"After resetting the login password, currency withdrawals and OTC transfers are prohibited within 24 hours.",
  请选择:"please choose",
  密码在:"The password is between 6-16 characters and consists of numbers and letters",
  请确认密码:"Please confirm your password",
  产品列表:"Product List",
  币种:"Currency",
  期限:"the term",
  订单列表:"Order List",
  交易用:"For trading",
  立即入金开始您的第一笔交易:"Deposit money now to start your first trade",
  立即入金:"Deposit now",
  币种对:"currency pair",
  涨幅:"Increase",
  交易量:"Trading volume",
  欢迎登录:"Login please",
  登录:"Log in",
  新用户注册:"New User Registration",
  总资产折合:"Total assets converted",
  冻结:"freeze",
  折合:"converted",
  充值币种:"Recharge currency",
  充值数量:"Recharge quantity",
  确认信息:"Confirm information",
  充币网络:"Deposit network",
  欢迎注册:"Welcome to register",
  点击打开:"Click to open",
  这是一段信息:"This is a piece of information",
  提币数量:"Amount of coins withdrawn",
  提币:"Withdraw coins",
  百万用户首选:"The first choice of millions of users",
  小时成交量:"24-hour trading volume",
  优质数字资产:"High quality digital assets",
  我们的核心产品:"Our core products",
  你可以选择丰富的交易方式:"You can choose from a variety of trading methods",
  现货:"Spot goods",
  我们提供:"we provide",
  币种的交易服务:"Currency trading services",
  合约:"contract",
  使用合约丰富你的交易体验:"Use contracts to enrich your trading experience",
  赚币:"Earn coins",
  行业内领先收益:"Industry-leading revenue",
  多元化的产品服务:"Diversified products and services",
  选择更多:"Choose more services and explore endless possibilities",
  福利中心:"Welfare center",
  完成新手任务:"Complete newbie tasks",
  会员:"member",
  享受全网最多权益:"Enjoy the most benefits on the entire network",
  社区:"Community",
  在这里发现币圈财富机会:"Discover wealth opportunities in the currency circle here",
  随时随地开启交易:"Start trading anytime, anywhere",
  全面支持:"Full support",
  和:"and",
  
  交割:"Delivery",
  关于我们:"about Us",
  账变记录:"Account change records",
  股票:"stock",
  加密货币:"Crypto",
  加载中:"loading...",
  已经全部加载完毕:"All have been loaded",
  暂无记录:"No records",
  高级认证:"Advanced certification",
  姓名:"Name",
  请输入姓名:"Please type in your name",
  护照编号:"Passport number",
  请输入护照编号:"Please enter passport number",
  护照照片:"passport photo",
  申请认证:"Apply for certification",
  提示:"hint",
  确定:"Sure",
  提交失败:"Submission Failed",
  上传失败:"upload failed",
  身份认证:"Authentication",
  身份证号:"ID number",
  请输入身份证号:"Please enter identification number",
  身份证照片:"ID photo",
  申请认证:"Apply for certification",
  修改资金密码:"Change fund password",
  旧密码:"Old Password",
  请输入旧密码:"Please enter old password",
  新密码:"New Password",
  请输入6位数字:"Please enter 6 digits",
  确认新密码:"Confirm the new password",
  请再次输入新密码:"Please enter new password again",
  提交:"Submit",
  请输入新密码:"Please enter a new password",
  请输入6位数新密码:"Please enter a new 6-digit password",
  请确认两次密码输入一致:"Please confirm that the two passwords entered are consistent",
  修改登录密码:"Change login password",
  密码长度:"Password (6-12 characters)",
  密码长度提示:"Please enter 6-12 characters, including numbers or letters",
  客服:"customer service",
  永续:"Sustainable",
  交割:"Delivery",
  永续合约:"Perpetual",
  交割合约:"Delivery",
  全仓:"Cross",
  开多:"Buy Long",
  开空:"Buy Short",
  价格:"price",
  开仓金额:"Opening amount",
  可用金额:"Available",
  合约金额:"Contract amount",
  保证金:"margin",
  手续费:"Handling Fee",
  看涨:"Bullish",
  看跌:"Bearish",
  交割时间:"delivery time",
  数量:"Quantity",
  持有仓位:"Position",
  当前委托:"Current order",
  历史订单:"Historical orders",
  暂无数据:"No data",
  购买价:"purchase price",
  现价:"Current price",
  市价: "Market price",
  限价: "Limit price",
  金额:"Amount",
  盈亏:"Profit and loss",
  操作:"operate",
  平仓:"Close position",
  撤单:"Cancel order",
  方向:"direction",
  剩余时间:"time left",
  交割时间:"delivery time",
  详情:"Details",
  名称:"Name",
  最新价格:"latest price",
  h24涨跌:"24H ups and downs",
  h24涨跌幅:"24H  Change",
  请输入开仓金额:"Please enter the opening amount",
  请输入开仓价格:"Please enter the opening price",
  确定执行撤单操作:"Are you sure you want to cancel the order?",
  确定执行平仓操作:"Are you sure to execute the position closing operation?",
  交割合约历史:"Delivery contract history",
  历史仓位:"Historical positions",
  到期时间:"Expire date",
  闪兑:"Flash exchange",
  从:"from",
  最大:"maximum",
  可用数量:"Quantity Available",
  至:"to",
  复制成功:"Copied successfully",
  基金理财:"Fund",
  托管金额:"Escrow amount",
  总收益:"Total revenue",
  当日收益:"Income of the day",
  托管订单:"Escrow order",
  规则:"rule",
  日收益:"Daily income",
  限额:"limit",
  周期:"cycle",
  天:"sky",
  立即买入:"Buy now",
  购买:"Buy",
  购买日:"Purchase date",
  起息日:"value date",
  派息时间:"Dividend payment time",
  每日:"daily",
  计息结束日:"Interest accrual end date",
  提前赎回:"early redemption",
  预计收益:"Estimated revenue",
  今日日收益:"Today (daily income)",
  最少可投:"Minimum investment",
  最大可投:"Maximum investment",
  请输入买入金额:"Please enter the purchase amount",
  可用金额:"Available",
  请输入买入金额:"Please enter the purchase amount",
  质押金额:"Pledge amount",
  累计收益:"Cumulative income",
  开始时间:"Starting time",
  结束时间:"End Time",
  理财规则:"financial rules",
  理财规则1:"Financial management is done by entrusting USDT to the platform, and the platform's professional team conducts financial arbitrage. Participants can obtain a share of the platform's financial management income during the fund custody period.",
  收益计算:"Revenue calculation",
  理财规则2:"A member deposits 10,000U on the platform and chooses a financial product with a cycle of 5 days and a daily income of 0.3%~0.5%. The daily income is as follows:",
  最低:"lowest",
  最高:"Highest",
  理财规则3:"Both: you can get it after 5 days",
  理财规则4:"The income is distributed daily. The distributed income can be accessed and withdrawn at any time and deposited into the principal. After maturity, it will be automatically returned to your account.",
  关于违约金:"About liquidated damages",
  理财规则5:"If you wish to transfer the unexpired principal, liquidated damages will be incurred.",
  理财规则6:"Liquidated damages = settlement ratio x remaining days x investment amount.",
  理财规则7:"Example: The liquidated damages settlement ratio of this product is",
  剩余:"Remaining",
  天到期投资:"It expires in days, and the investment amount is",
  则:"but",
  违约金:"liquidated damages",
  实际退还本金为:"The actual principal returned is",
  现货账户:"Spot account",
  总资产:"Total assets",
  充币:"Deposit ",
  提币:"Withdraw ",
  闪兑:"Exchange",
  投资组合:"portfolio",
  冻结数量:"Freeze",
  帮助中心:"Help Center",
  自选:"Optional",
  行情:"Quotes",
  资金:"Funds",
  资讯:"Information",
  我的:"Mine",
  交易对:"Trading pair",
  最新价:"Latest price",
  成交量:"Volume",
  标记价格:"Mark price",
  h24最高价:"24h high",
  h24最低价:"24h low",
  h24成交量:"24h Vol",
  h24交易额:"24h Vol",
  分时:"Line",
  分1:"1m",
  分5:"5m",
  分15:"15m",
  分30:"30m",
  小时1:"1H",
  天1:"1D",
  周1:"1W",
  月1:"1M",
  委托订单:"Order",
  最新交易:"Latest transactions",
  买入:"Buy",
  卖出:"sell",
  时间:"time",
  方向:"direction",
  取消自选成功:"Cancel selection successfully",
  添加成功:"Added successfully",
  登录:"Login",
  账户:"Account",
  邮箱:"Email",
  手机号:"Phone number",
  请输入账户:"Please enter account",
  请输入邮箱:"please input your email",
  请输入手机号:"Please enter phone number",
  密码:"Password",
  请输入密码:"Please enter password",
  忘记密码:"Forget the password?",
  还没有账号:"No account yet",
  去注册:"To register",
  请输入登录账号:"Please enter your login account",
  请输入登录密码:"Please enter your password",
  登录失败:"Login failed",
  历史记录:"History record",
  充值:"Top up",
  提现:"Withdraw",
  未审核:"Not reviewed",
  成功:"success",
  失败:"fail",
  快捷入口:"Quick entry",
  资金密码:"Fund pwd",
  登录密码:"Login pwd",
  账变记录:"Record",
  邀请推广:"Invite ",
  通用:"Universal",
  语言:"Language",
  在线客服:"Online service",
  身份认证:"Authentication",
  高级认证:"Advanced certification",
  更多:"More",
  帮助中心:"Help Center",
  关于我们:"About Us",
  退出:"Exit",
  已提交身份认证:"You have submitted your identity information and it is under review",
  您已完成身份认证:"You have completed identity verification",
  您已完成高级认证:"You have completed Advanced Certification",
  确定退出登录:"Are you sure you want to log out?",
  资讯:"Information",
  公告:"announcement",
  状态:"state",
  已成交:"Deal done",
  委托金额:"Commission amount",
  剩余金额:"balance",
  订单类型:"Order Type",
  市价委托:"market order",
  限价委托:"limit order",
  订单号:"order number",
  委托时间:"Commission time",
  U本位合约历史:"U-based contract history",
  成交数量:"The number of transactions",
  实现盈亏:"Realize profit and loss",
  推广记录:"Promotion record",
  我的总推广:"My general promotion",
  总充值:"Total recharge",
  一代人数:"Number of generations",
  二代人数:"Number of second generation",
  三代人数:"Number of three generations",
  立即推广:"Promote now",
  我的推广:"my promotion",
  用户名:"username",
  行情:"Quotes",
  加密货币:"Crypto",
  外汇:"Forex",
  股票:"Stock",
  现货交易:"Spot Trading",
  热门:"Popular",
  涨幅榜:"Increas",
  跌幅榜:"Decline",
  快速充币:"Quick deposit",
  保存二维码:"Save QR code",
  复制地址:"Copy address",
  转出地址:"Transfer-out address (optional)",
  请输入转出地址:"Please enter the transfer-out address",
  粘贴:"Paste",
  充币数量:"Deposit amount",
  请输入充币数量:"Please enter the deposit amount",
  区块链网络:"Blockchain network",
  付款凭证:"Payment voucher (upload screenshot of payment details)",
  请输入充值数量:"Please enter the recharge amount",
  充值通道:"Recharge channel",
  请选择充值币种:"Please select the recharge currency",
  官方充值通道:"Official recharge channel",
  设置密码:"set password",
  确认密码:"Confirm Password",
  验证码:"Verification code",
  请输入验证码:"please enter verification code",
  获取验证码:"get verification code",
  重新发送:"Resend",
  邀请码:"Invitation code",
  请输入邀请码:"Please enter the invitation code",
  我已阅读并同意:"I have read and agree",
  服务条款:"Terms of Service",
  注册:"Register",
  已有账号:"Already have an account",
  去登录:"Go to login",
  请再次输入密码:"Please enter password again",
  请同意服务条款:"Please agree to the terms of service",
  注册失败:"registration failed",
  欢迎来到:"Welcome to",
  全球最大的区块链资产平台:"The world's largest blockchain asset platform",
  分享二维码:"Share QR code",
  链接分享:"Link sharing",
  复制:"copy",
  您的邀请码:"your invitation code",
  到数字币地址:"To the digital currency address",
  选择币种:"Select currency",
  区块链网络:"Blockchain network",
  提币说明:"Withdrawal instructions",
  提现费用:"Withdrawal fees",
  可到账数量:"Available quantity",
  可用:"Available",
  请输入支付密码:"Please enter payment password",
  请输入提币数量:"Please enter the withdrawal amount",
  全部:"all",
  支付密码:"Payment password",
  地址:"address",
  委托价:"Order price",
  成交时间:"Transaction time",
  成交金额:"Turnover",
  委托中:"On commission",
  持仓中:"In position",
  平仓中:"Position closing",
  已平仓:"Position closed",
  开仓倍数:"Opening multiple",
  委托价格:"Commission price",
  收盘价:"Closing price",
  收益率:"rate of return",
  平仓时间:"Closing time",
  请输入转换数量:"Please enter the conversion quantity",
  请上传付款凭证:"Please upload payment voucher",
  开盘价:"opening price",
  开市中:"Open",
  已休市:"The market has been closed",
  美股:"US stocks",
  平仓价:"Closing price",
  到期结算完成:"Maturity settlement completed",
  印度股票:"IN Stocks",
  马来股票:"Malay stocks",
  结算中:"Settling",
  越南股票:"VN Stocks",
  设置资金密码:"Set fund password",
  请输入资金密码:"Please enter the fund password",

  取消:"Cancel",
  确定:"Sure",
  止损价:"Stop loss price",
  请输入止损价格:"Please enter stop loss price",
  请输入止盈价格:"Please enter the take profit price",
  止盈价:"Take profit price",
  设置止盈止损:"Set price",
  请输入关键词:"Please enter a keyword",
  搜索结果:"search results",
  添加收款方式:"Add payment method",
  高级认证:"Advanced certification",
  历史委托:"historical commission",
  选择区域码:"Select area code",
  请上传身份证图片:"Please upload a picture of your ID card",
  请上传护照照片:"Please upload passport photo",
  请输入提币地址:"Please enter the withdrawal address",
  设置语言:"language setting",
  最低金额: "Mindestbetrag",
  购买金额: "Purchasing price",
  请输入要搜索的国家名称: "Please enter the name of the country you want to search for",
  确定执行该操作: "Confirm to do this?",
  历史搜索: "Historical searches",
  现货持仓: "Spot position",
  永续持仓: "Perpetual position",
  到期结算中: "Settling at maturity",
  火花图: "Diagram",
  计价单位: "sales unit",
  您拒绝了链接: "You rejected the link",
  连接钱包成功: "Wallet connection successful",
  已断开钱包: "Wallet disconnected",
  钱包切换成功: "Wallet switch successful",
  请先安装钱包插件: "Please install the wallet plug-in first",
  连接钱包: "Connect wallet",
  交易: "Trade",
  确认报价: "Confirm quotation",
  您将获得: "you will get",
  兑换自: "Redeem from",
  汇率: "exchange rate",
  返回: "return",
  兑换: "exchange",
  消息: "message",
  身份证反面照片: "Photo of the reverse side of ID card",
  身份证正面照片: "ID card front photo",
  手持身份证照片: "Photo of holding ID card",
  划转: "transfer",
  请输入划转数量: "Please enter the transfer amount(USDT)",
  消息: "Information",
  邀请链接: "Invitation link",
  资料总览: "Overview",
  推广规则: "Promotion rules",
  总邀请人数: "Total number of invitees",
  总佣金: "Total commission",
  安全绑定: "Secure binding",
  规则1: "1. This address only accepts {type}. Please do not transfer non-{type} assets to this address, otherwise the assets will not be retrieved.",
  规则2: "2. After you recharge the above address, you need to wait for the network node to confirm. Once the network node confirms, the assets will automatically arrive in your account. We will notify you of the arrival status in the form of a website announcement.",
  规则3: "3. Your recharge address will not change frequently and you can recharge repeatedly; if there is any change, we will notify you through a website announcement",

  安全中心: "Security center",
  绑定手机号: "Bind mobile phone number",
  认证中心: "Certification Center",
  身份认证: "Authentication",
  认证要求: "Certification requirements",
  政府发行的证件: "Government issued documents",
  功能与限制: "Features and limitations",
  无限额: "No limit",
  预计审核时间: "Estimated review time: 60 minutes",
  开始认证: "Start certification",
  充币规则: "Deposit rules",
  加密货币股票多类选择: "Cryptocurrency Stocks Multiple Selection",
    个人中心: "Personal center",
    充值记录: "Recharge record",
    提现记录: "Withdrawals record"
    
    
  }
  
  
  


// WEBPACK FOOTER //
// ./src/lang/en.js